<template>
  <div>
    <div class="body">
      <div class="search">
        <div class="item">
          <!-- 返回上一页 -->
          <el-button type="text" @click="$parent.$parent.type = 'chatSummary'">《《{{ $t('message.GoBack') }}</el-button>
        </div>
        <div class="item title">
          CHATWORK
        </div>
      </div>
      <div class="tabs">
        <el-tabs v-model="datas.statusGroup" type="card" @tab-click="search">
          <!-- 待内部处理 -->
          <el-tab-pane :label="$t('message.pendingInternalProcessing')" name="待内部处理"></el-tab-pane>
          <!-- 待部长审核 -->
          <el-tab-pane :label="$t('message.ToBeReviewedByTheMinister')" name="待部长审核"></el-tab-pane>
          <!--待日本确认  -->
          <el-tab-pane :label="$t('message.subjectToJapanConfirmation')" name="待日本确认"></el-tab-pane>
          <!--待部长确认  -->
          <el-tab-pane :label="$t('message.waitingForTheMinisterSReplyToConfirm')" name="待部长确认"></el-tab-pane>
          <!-- 已处理完成 -->
          <el-tab-pane :label="$t('message.Processed')" name="已处理完成"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="search" v-if="datas.statusGroup == '已处理完成'">
        <el-select v-model="datas.status" clearable>
          <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-button type="primary" style="margin-left: 20px;" @click="search">{{ $t('message.search') }}</el-button>
      </div>
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" border v-if="show">
          <!-- 发送对象 -->
          <el-table-column align="center" :label="$t('message.sendTo')" prop="send_realname" width="100">
            <template slot-scope="scope">
              <p>{{ scope.row.send_realname }}</p>
              <p>{{ scope.row.send_time }}</p>
            </template>
          </el-table-column>
          <!-- 匹配/处理/审核/确认 -->
          <el-table-column align="center" :label="$t('message.fourSteps')" prop="send_realname" width="225"
            v-if="datas.statusGroup == '待日本确认' || datas.statusGroup == '已处理完成'">
            <template slot-scope="scope">
              <!-- 匹配 -->
              <p>
                {{ $t('message.mate') }}:
                {{ scope.row.chatwork_message_tag.created_at }}
              </p>
              <!-- 处理 -->
              <p>
                {{ $t('message.businessProcessing') }}:
                {{ scope.row.chatwork_message_tag.y_deal_at }}
              </p>
              <!-- 审核 -->
              <p>
                {{ $t('message.ministerialReview') }}:
                {{ scope.row.chatwork_message_tag.depart_deal_at }}
              </p>
              <!-- 确认 -->
              <p>
                {{ $t('message.japanConfirms') }}:
                {{ scope.row.chatwork_message_tag.confirm_at }}
              </p>
              <!-- 部长确认 -->
              <p>
                {{ $t('message.ministerConfirms') }}:
                {{ scope.row.chatwork_message_tag.depart_reconfirm_at }}
              </p>

            </template>
          </el-table-column>
          <!-- 聊天内容 -->
          <el-table-column align="center" :label="$t('message.chatContent')">
            <template slot-scope="scope">
              <div v-html="scope.row.body" @dblclick="getCWComplainMessageContext(scope.row.id)" class="text-left">
              </div>
            </template>
          </el-table-column>
          <!-- 处理截图 -->
          <el-table-column align="center" :label="$t('message.ProcessScreenshots')" v-if="datas.statusGroup != '待内部处理'">
            <template slot-scope="scope">
              <el-image style="width: 60px; height: 60px;margin-right: 10px;" :src="item" :preview-src-list="[item]"
                v-for="(item, index) in scope.row.chatwork_message_tag.deal_images" :key="index">
              </el-image>
            </template>
          </el-table-column>
          <!-- 处理思路 -->
          <el-table-column align="center" :label="$t('message.handlingIdeas')" width="200">
            <template slot-scope="scope">
              <el-input type="textarea" v-model="scope.row.chatwork_message_tag.remark"
                @blur="dealUpdateRemark(scope.row)" :disabled="datas.statusGroup != '待内部处理'"></el-input>
            </template>
          </el-table-column>
          <!-- 部长留言 -->
          <el-table-column align="center" :label="$t('message.MinistersMessage')" width="200"
            v-if="datas.statusGroup != '待内部处理'">
            <template slot-scope="scope" v-if="scope.row.chatwork_message_tag.status != 20">
              <el-image style="width: 60px; height: 60px;margin-right: 10px;" :src="item" :preview-src-list="[item]"
                v-for="(item, index) in scope.row.chatwork_message_tag.depart_images" :key="index">
              </el-image>
              <el-input type="textarea" v-model="scope.row.chatwork_message_tag.depart_remark"
                @blur="dealUpdateDepartRemark(scope.row)"
                :disabled="datas.statusGroup != '待部长审核' || !isAuth(576)"></el-input>
            </template>
          </el-table-column>
          <!-- 待日本确认 -->
          <el-table-column align="center" :label="$t('message.subjectToJapanConfirmation')" width="200"
            v-if="datas.statusGroup != '待内部处理' && datas.statusGroup != '待部长审核'">
            <template slot-scope=" scope" v-if="scope.row.chatwork_message_tag.status != 20">
              <el-input type="textarea" v-model="scope.row.chatwork_message_tag.japan_remark"
                @blur="dealUpdateJapanRemark(scope.row)"
                :disabled="datas.statusGroup != '待日本确认' || !isAuth(552)"></el-input>
            </template>
          </el-table-column>
          <!-- 评分 -->
          <el-table-column align="center" :label="$t('message.score')" width="200" v-if="datas.statusGroup == '已处理完成'">
            <template slot-scope=" scope" v-if="scope.row.chatwork_message_tag.status != 20">
              <!-- *问题严重程度： -->
              <div class="row">
                {{ $t('message.SeveritProblem') }} : <span><el-rate
                    v-model="scope.row.chatwork_message_tag.score_severity" disabled></el-rate></span>
              </div>
              <!-- **客户重要程度 -->
              <div class="row">
                {{ $t('message.CustomeImportance') }} : <span><el-rate
                    v-model="scope.row.chatwork_message_tag.score_priority" disabled></el-rate></span>
              </div>
              <!-- 业务解决问题的情况 -->
              <div class="row">
                {{ $t('message.BusinessSituation') }} : <span><el-rate
                    v-model="scope.row.chatwork_message_tag.score_resolution" disabled></el-rate></span>
              </div>
              <!-- *发现问题-解决问题时长： -->
              <div class="row">
                {{ $t('message.ProblemSolvingDuration') }} : <span><el-rate
                    v-model="scope.row.chatwork_message_tag.score_timeliness" disabled></el-rate></span>
              </div>
            </template>
          </el-table-column>
          <!-- 部长确认回复 -->
          <el-table-column align="center" :label="$t('message.ministerConfirmsReply')" width="200"
            v-if="datas.statusGroup != '待内部处理' && datas.statusGroup != '待部长审核' && datas.statusGroup != '待日本确认'">
            <template slot-scope=" scope" v-if="scope.row.chatwork_message_tag.status != 20">
              <el-input type="textarea" v-model="scope.row.chatwork_message_tag.depart_reconfirm_remark"
                @blur="updateDepartReconfirmRemark(scope.row)"
                :disabled="datas.statusGroup != '待部长确认' || !isAuth(581)"></el-input>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')" width="100"
            v-if="datas.statusGroup != '已处理完成'">
            <template slot-scope="scope">
              <!--待内部处理  -->
              <div v-if="datas.statusGroup == '待内部处理'">
                <!-- 确认为投诉 -->
                <p style="margin-bottom: 10px;">
                  <el-button type="primary" size="mini" @click="RCComplainConfirm(scope.row)" v-if="isAuth(553)">
                    {{ $t('message.confirmedComplaint') }}
                  </el-button>
                </p>
                <el-button type="primary" size="mini" class="dark" @click="RCComplainReject(scope.row)"
                  v-if="isAuth(553)">
                  {{ $t('message.nonComplaint') }}
                </el-button>
              </div>
              <!--待部长审核  -->
              <div v-if="datas.statusGroup == '待部长审核' && isAuth(576)">
                <!-- 立即审核 -->
                <el-button type="primary" size="mini" @click="ImmediateReview(scope.row)">
                  {{ $t('message.ImmediateReview') }}
                </el-button>
              </div>
              <!--待日本确认  -->
              <div v-if="datas.statusGroup == '待日本确认' && isAuth(552)">
                <!-- 确认 -->
                <el-button type="primary" size="mini" @click="notarize(scope.row)">
                  {{ $t('message.notarize') }}
                </el-button>
              </div>
              <!--待部长确认  -->
              <div v-if="datas.statusGroup == '待部长确认' && isAuth(581)">
                <!-- 确认 -->
                <el-button type="primary" size="mini" @click="toDepartReConfirmed(scope.row)">
                  {{ $t('message.notarize') }}
                </el-button>
              </div>
            </template>
          </el-table-column>
          <!-- 类型-->
          <el-table-column align="center" :label="$t('message.type')" width="100" v-else>
            <template slot-scope="scope">
              {{ scope.row.chatwork_message_tag.status == 20 ? $t('message.nonComplaint') :
                $t('message.confirmedComplaint') }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[100, 200, 500,]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 上下50条 -->
    <el-dialog :title="$t('message.upAndDown')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1200px" center>
      <div class="content">
        <div class="table">
          <el-table :data="upAndDownList" :default-sort="{ prop: 'date', order: 'descending' }"
            :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" max-height="600px">
            <!-- 发送对象 -->
            <el-table-column align="center" :label="$t('message.sendTo')" prop="send_realname" width="150">
            </el-table-column>
            <!-- 发送时间 -->
            <el-table-column align="center" :label="$t('message.sendingTime')" prop="send_time" width="150">
            </el-table-column>
            <!-- 聊天内容 -->
            <el-table-column align="center" :label="$t('message.chatContent')" prop="realname">
              <template slot-scope="scope">
                <div v-html="scope.row.body" class="text-left"></div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    <!-- 客户投诉处理 -->
    <!-- <toWaitDepart ref="toWaitDepart" /> -->
    <!-- 非投诉 -->
    <!-- <toCancel ref="toCancel" /> -->
    <!-- 待部长审核-提交到下一步 -->
    <!-- <toWaitJapan ref="toWaitJapan" /> -->
    <!-- 日本确认 -->
    <!-- <toConfirmed ref="toConfirmed" /> -->
    <!-- 待部长确认-提交到下一步 -->
    <!-- <toDepartReConfirmed ref="toDepartReConfirmed" /> -->
  </div>
</template>
<script>
// import toWaitDepart from './toWaitDepart'
// import toCancel from './toCancel'
// import toWaitJapan from './toWaitJapan'
// import toConfirmed from './toConfirmed'
// import toDepartReConfirmed from './toDepartReConfirmed'
export default {
  components: {
    // toWaitDepart,
    // toCancel,
    // toWaitJapan,
    // toConfirmed,
    // toDepartReConfirmed
  },
  props: {
    complainDetail: { type: Object },
  },
  data() {
    return {
      datas: {
        user_id: '',
        status: '',
        statusGroup: '',
      },
      total: 0,
      tableData: [],
      upAndDownList: [],
      dialogVisible: false,
      show: true
    };
  },
  computed: {
    option() {
      return [
        { value: '10', label: this.$t('message.confirmedComplaint') },
        { value: '20', label: this.$t('message.nonComplaint') },
      ]
    },
  },
  created() {
    this.datas.status = this.complainDetail.status
    this.datas.statusGroup = this.complainDetail.statusGroup
    this.cwMessageListComplain()
  },
  methods: {
    cwMessageListComplain() {
      this.show = false
      this.datas.user_id = this.complainDetail.id
      this.$api.siteConfiguration.cwMessageListComplain(this.datas).then(res => {
        this.show = true
        res.data.data.forEach(item => {
          item.hitKeywords.forEach(items => {
            item.body = item.body.replaceAll(items, `<span style='color:#B4272D'>${items}</span>`)
          })
          item.chatwork_message_tag.score_severity = item.chatwork_message_tag.score_severity - 0
          item.chatwork_message_tag.score_resolution = item.chatwork_message_tag.score_resolution - 0
          item.chatwork_message_tag.score_priority = item.chatwork_message_tag.score_priority - 0
          item.chatwork_message_tag.score_timeliness = item.chatwork_message_tag.score_timeliness - 0
        })
        this.tableData = res.data.data
        this.total = res.data.total
      })
    },
    search() {
      if (this.datas.statusGroup != '已处理完成') {
        this.datas.status = ''
      }
      this.datas.page = 1
      this.cwMessageListComplain()
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.cwMessageListComplain()
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.cwMessageListComplain()
    },
    // 处理编辑备注
    dealUpdateRemark(row) {
      let datas = {
        ids: [row.chatwork_message_tag.id],
        type: 'CW',
        content: row.chatwork_message_tag.remark,
      }
      this.$api.siteConfiguration.dealUpdateRemark(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    // 待部长审核-实时修改部长留言
    dealUpdateDepartRemark(row) {
      let datas = {
        ids: [row.chatwork_message_tag.id],
        type: 'CW',
        content: row.chatwork_message_tag.depart_remark,
      }
      this.$api.siteConfiguration.dealUpdateDepartRemark(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    // 待部长审核-实时待日本确认 
    dealUpdateJapanRemark(row) {
      let datas = {
        ids: [row.chatwork_message_tag.id],
        type: 'CW',
        content: row.chatwork_message_tag.japan_remark,
      }
      this.$api.siteConfiguration.dealUpdateJapanRemark(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    // 待部长确认-实时修改待部长确认备注
    updateDepartReconfirmRemark(row) {
      let datas = {
        ids: [row.chatwork_message_tag.id],
        type: 'CW',
        content: row.chatwork_message_tag.depart_reconfirm_remark,
      }
      this.$api.siteConfiguration.updateDepartReconfirmRemark(datas).then(res => {
        this.$message.success(res.msg)
      })
    },

    //非投诉
    RCComplainReject(item) {
      this.$refs.toCancel.datas = {
        id: item.chatwork_message_tag.id,
        type: 'CW',
        content: item.chatwork_message_tag.remark,
      }
      this.$refs.toCancel.dialogVisible = true
    },
    //  部長审核
    ImmediateReview(item) {
      this.$refs.toWaitJapan.datas = {
        id: item.chatwork_message_tag.id,
        type: 'CW',
        content: item.chatwork_message_tag.depart_remark,
        is_complain: '1',
      }
      this.$refs.toWaitJapan.dialogVisible = true
    },
    // RC聊天上下50条上下文
    getCWComplainMessageContext(id) {
      this.$api.siteConfiguration.getCWComplainMessageContext({ id }).then(res => {
        this.upAndDownList = res.data
        this.dialogVisible = true
      })
    },
    //确认
    RCComplainConfirm(item) {
      this.$refs.toWaitDepart.datas = {
        id: item.chatwork_message_tag.id,
        type: 'CW',
        content: item.chatwork_message_tag.remark,
        deal_images: [],
      }
      this.$refs.toWaitDepart.dialogVisible = true
    },
    // 日本确认
    notarize(item) {
      this.$refs.toConfirmed.datas = {
        id: item.chatwork_message_tag.id,
        type: 'CW',
        content: item.chatwork_message_tag.japan_remark,
      }
      this.$refs.toConfirmed.dialogVisible = true
    },
    // 部长确认回复
    toDepartReConfirmed(item) {
      this.$refs.toDepartReConfirmed.datas = {
        id: item.chatwork_message_tag.id,
        type: 'CW',
        content: item.chatwork_message_tag.depart_reconfirm_remark,
      }
      this.$refs.toDepartReConfirmed.dialogVisible = true
    },
  }
}
</script>
<style lang='scss' scoped>
/deep/ .el-textarea__inner {
  min-height: 120px !important;
  padding: 3px;
  background-color: #fff !important;
  color: #606266 !important;
}

.search {
  display: flex;

  .item {
    margin-right: 24px;

  }

  .title {
    line-height: 40px;
    margin: 0 48px;
  }
}

.tabs {
  margin: 24px 0 0;
}

.table {
  margin: 24px 0;


}

.text-left {
  text-align: left;
}
</style>